/*
 * @author Mateusz Mieszczak <mateusz.mieszczak at bossbyte.com>
 * @copyright BossByte Web Application
 */


app.controller('MessageNew', function($scope, $rootScope, mailboxService, recipientService,
    $stateParams, Upload, _$editmode,$mdDialog,uiGmapGoogleMapApi) {

    _$editmode.turnOn();

    $scope.id = $stateParams.id;

    $scope.tab = {
        "selected": 0,
        "change": function(kind, form) {
            var result = true;
            if ($scope.tab.editable && typeof form != "undefined") {
                result = $scope.check(form);
            }
            if (result)
                $scope.tab.selected = kind == 'next' ? $scope.tab.selected + 1 : $scope.tab.selected - 1;
        },
        "title": $scope.id ? "Edycja wiadomości" : "Nowa wiadomość",
        "kind": "",
        "editable": true,
        "button": "Wyślij",
        "details": false
    };

    $scope.search = {
        "clearButton": false,
        "clearButtonPressed": false,
        "changeKind": function() {
            $scope.row.content.filter.age = '';
        },
        "changeGroup": function() {
            $scope.search.run();
        },
        "clear": function() {
            if ($scope.row.content.filter.all) {
                $scope.search.clearButton = false;
                $scope.search.clearButtonPressed = true;
                $scope.row.content.filter = {
                    'all': 1,
                    'kind': 0,
                    //'sex': 0
                };
                $scope.search.empty();
                $scope.search.run();
            }
        },
        clearFilters: function() {
            if ($scope.row.content.filter.kind == 'advanced') {
                $scope.search.empty();
                $scope.search.clearButton = false;
                $scope.search.clearButtonPressed = true;
            }
        },
        "empty": function() {
            $scope.row.content.filter.name = "";
            $scope.row.content.filter.sex = '';
            $scope.row.content.filter.name = '';
            $scope.row.content.filter.surname = '';
            $scope.row.content.filter.county = '';
            $scope.row.content.filter.comunity = '';
            $scope.row.content.filter.street = '';
            $scope.row.content.filter.city = '';
            $scope.row.content.filter.postcode = '';
            $scope.row.content.filter.age = '';
            $scope.row.content.filter.age_before = '';
            $scope.row.content.filter.age_after = '';
            if (!$scope.data.subunit)
                $scope.row.content.unit = [];

            $scope.autocompletes = {
                "county": [],
                "city": [],
                "comunity": [],
                "street": []
            };
        },
        "list": {},
        "run": function() {
            var params = angular.copy($scope.row.content.filter);
            var units = angular.copy($scope.row.content.unit);
            var teams = angular.copy($scope.row.content.team);

            if ($scope.data.subunit)
                params.all = 0;

            params.active = 1;
            params.verified = 1;
            params.contact = 1;

            if (params.all == 0) {
                if ($scope.data.subunit)
                    params.unit_id = $scope.data.subunit_id;
                else if (typeof units != "undefined" && units.length > 0)
                    params.unit_id = units.join();
                if (typeof teams != "undefined" && teams.length > 0)
                    params.team_id = teams.join();
                if (typeof params.age_before == "object")
                    params.age_before = $rootScope.formatDate(params.age_before);
                if (typeof params.age_after == "object")
                    params.age_after = $rootScope.formatDate(params.age_after);

                if ($scope.autocompletes.city.length > 0)
                    params.city = _.map($scope.autocompletes.city, 'name').join();
                if ($scope.autocompletes.county.length > 0)
                    params.county = _.map($scope.autocompletes.county, 'name').join();
                if ($scope.autocompletes.comunity.length > 0)
                    params.comunity = _.map($scope.autocompletes.comunity, 'name').join();
                if ($scope.autocompletes.street.length > 0)
                    params.street = _.map($scope.autocompletes.street, 'name').join();
            }

            var promise = recipientService.list(1, params);
            promise.then(
                function(payload) {
                    $scope.search.list = payload.data;
                },
                function(errorPayload) {
                    $rootScope.notification.show('error', 'Błąd ładowania odbiorców');
                });
        },
        "showClearButton": function() {
            if ($scope.listReady && $scope.row.content.filter.kind == 'advanced' && !$scope.search.clearButtonPressed) {
                $scope.search.clearButton = true;
            } else {
                $scope.search.clearButtonPressed = false;
                $scope.search.clearButton = false;
            }
        }
    };

    $scope.$watch('row.content.filter', function(newValue, oldValue) {
        if (typeof newValue.kind != "undefined" && newValue.kind == oldValue.kind)
            $scope.search.showClearButton();
    }, true);
    $scope.$watch('row.content.unit', function() {
        $scope.search.showClearButton();
    }, true);
    $scope.$watch('row.content.team', function() {
        $scope.search.showClearButton();
    }, true);
    $scope.$watch('autocompletes', function(newValue, oldValue) {
        if ((newValue.county.length > 0) ||
            (newValue.comunity.length > 0) ||
            (newValue.city.length > 0) ||
            (newValue.street.length > 0))
            $scope.search.showClearButton();
    }, true);

    $scope.data = {
        "categories": [],
        "notifications": [],
        "sended_notifications": [],
        "receiver_list": [],
        "sendDateMin": new Date().getFullYear() + "-" + (new Date().getMonth() + 1),
        "subunit": false,
        "subunit_id": false,
        "emailsettings": {},
        "available_notifications": [],
        "unitSupported": false,
        "teamSupported": false,
        "languages": [],
        "activeNotifications": []
    };

    $scope.row = {
        'send_date': '',
        'ready_to_send': false,
        'send_now': false,
        'mobile_available': '',
        'content': {
            'only_sms': false,
            'subject': '',
            'notification_category_id': null,
            'short_msg': '',
            'long_msg': '',
            'mobile_msg': '',
            'photo': '',
            'link': '',
            'lat': null,
            'lng': null,
            'filter': {
                'all': 1,
                'kind': 0,
                'age': ''
            },
            'attachment': [],
            'notification': [],
            'receiver': [],
            'unit': [],
            'team': []
        },
        'scheduler': {
            'send_type': '',
            'repeat_value': '',
            'send_from': '',
            'send_to': '',
            'date': []
        },
        'actions': {
            'template': {
                'set': false,
                'name': ''
            },
            'receivergroup': {
                'set': false,
                'name': ''
            }
        },
        "priority": []
    };

    $scope.notavailable = {
        "sms": false,
        "mobile": true,
        "email": false,
        "epuap": false,
        "available_to": true,
        "mobile_read_confirm": true,
        "send_all_mobile_notification": true
    };

    $scope.mobileNotificationId;

    $scope.$watch("row.content.only_sms", function(value) {
        if (parseInt(value, 10) == 1) {
            $scope.notavailable.email = true;
            $scope.notavailable.epuap = true;
            $scope.notavailable.mobile = true;
            $scope.notavailable.sms = false;

            for (var i = 0; i < $scope.data.notifications.length; i++) {
                if ($scope.data.notifications[i].symbol == "sms") {
                    $scope.row.content.notification = ["" + $scope.data.notifications[i].id];
                    $scope.row.priority = [$scope.data.notifications[i].id];
                }
            }

        } else {
            $scope.notavailable.email = $scope.row.content.mobile_msg == "";
            $scope.notavailable.epuap = $scope.row.content.long_msg == "";
            $scope.notavailable.mobile = $scope.row.content.mobile_msg == "";
            $scope.notavailable.sms = $scope.row.content.short_msg == "" || typeof $scope.row.content.short_msg==="undefined";

            if($scope.notavailable.sms && $scope.data.notifications.length>0){
              for (var i = 0; i < $scope.data.notifications.length; i++) {
                if ($scope.data.notifications[i].symbol == "sms") {
                  var index = $scope.row.content.notification.indexOf("" + $scope.data.notifications[i].id);
                  if (index !== -1) $scope.row.content.notification.splice(index, 1);
                  var index = $scope.row.priority.indexOf($scope.data.notifications[i].id);
                  if (index !== -1) $scope.row.priority.splice(index, 1);
                }
              }
            }
        }
    });

    $scope.$watch("row.content.long_msg", function(value) {
        $scope.notavailable.epuap = (value == "");
    });

    $scope.$watch("row.content.mobile_msg", function(value) {
        $scope.notavailable.email = (value == "");
        $scope.notavailable.mobile = (value == "");
    });

    $scope.$watch("row.content.short_msg", function(value) {
        $scope.notavailable.sms = (value == "");
    });

    $scope.autocompletes = {
        "county": [],
        "city": [],
        "comunity": [],
        "street": []
    };

    $scope.check = function(form) {
        // console.log($scope.row);
        // console.log($scope.notavailable);
        // console.log($scope.data.notifications);
        // console.log($scope.data.available_notifications);

        if (form.$valid) {
            var valid = true;
            if (form.$name == "messageSendForm") {
                valid = $scope.scheduler.checkValid();
            }
            return valid;
        } else {
            angular.forEach(form.$error, function(field) {
                console.log(field);
                angular.forEach(field, function(f) {
                    console.log(f);
                    f.$setDirty();
                    f.$setTouched();
                });
            });

            $rootScope.notification.show('error', 'Formularz nie został prawidłowo wypełniony');
        }
    };

    $scope.send = function(form) {
        var validChannels = true,
            notification, invalid = [];
        for (var i = 0; i < $scope.data.notifications.length; i++) {
            notification = $scope.data.notifications[i];
            if ($.inArray(notification.id.toString(), $scope.row.content.notification) != -1 && ($.inArray(notification.symbol, $scope.data.available_notifications) == -1 || $scope.notavailable[notification.symbol] == true)) {
                validChannels = false;
                invalid.push(notification.symbol);
            }
        }

        if (!validChannels) {
            $rootScope.notification.show('error', 'Następujące metody wysyłki (' + invalid.join() + ') nie są aktualnie dostępne');
        } else {
            delete $scope.row.draft;
            $scope.save(form);
        }
    };

    $scope.save = function(form) {
        var params = angular.copy($scope.row);

        params.content.filter.county = $scope.autocompletes.county.length > 0 ? _.map($scope.autocompletes.county, 'name').join() : "";
        params.content.filter.comunity = $scope.autocompletes.comunity.length > 0 ? _.map($scope.autocompletes.comunity, 'name').join() : "";
        params.content.filter.city = $scope.autocompletes.city.length > 0 ? _.map($scope.autocompletes.city, 'name').join() : "";
        params.content.filter.street = $scope.autocompletes.street.length > 0 ? _.map($scope.autocompletes.street, 'name').join() : "";

        params.mobile_available = $rootScope.formatDate(params.mobile_available);
        if (params.scheduler.send_type == "repeat") {
            if (typeof params.scheduler.send_from != "string" || (typeof params.scheduler.send_from == "string" && params.scheduler.send_from.length != 10))
                params.scheduler.send_from = $rootScope.formatDate(params.scheduler.send_from);
            if (typeof params.scheduler.send_to != "string" || (typeof params.scheduler.send_to == "string" && params.scheduler.send_to.length != 10))
                params.scheduler.send_to = $rootScope.formatDate(params.scheduler.send_to);

        } else if (params.scheduler.send_type == "scheduler") {
            for (var i = 0; i < params.scheduler.date.length; i++) {
                if (typeof params.scheduler.date[i].send_date != "string" || (typeof params.scheduler.date[i].send_date == "string" && params.scheduler.date[i].send_date.length != 10))
                    params.scheduler.date[i].send_date = $rootScope.formatDate(params.scheduler.date[i].send_date);
            }
        }

        if (typeof params.send_date == "object" && params.send_date!=null) {
          params.send_date = $rootScope.formatDateFromObjectToString(params.send_date);
        }
        //params.send_date = $rootScope.formatDate(params.send_date);

        var redirect = $scope.row.send_now ? 'message_send' : 'message_waiting';

        var hasEpuapNotification = false;
        for(var i=0; i < $scope.row.content.notification.length;i++){
          for (var j = 0; j < $scope.data.notifications.length; j++) {
              if(parseInt($scope.row.content.notification[i]) == $scope.data.notifications[j].id
                && $scope.data.notifications[j].symbol == 'epuap')
                hasEpuapNotification = true;
          }
        }
        if($scope.row.send_now && hasEpuapNotification)
          redirect = 'message_waiting';

        var promise = $scope.id ? mailboxService.update($scope.id, params) : mailboxService.store(params);
        promise.then(
            function(payload) {
                if (payload.data.code == 1) {
                    if ($scope.upload.photo.data != "" || $scope.upload.attachment.data.length > 0) {
                        promise = mailboxService.upload({
                            "id": $scope.id ? $scope.id : payload.data.id,
                            "photo": $scope.upload.photo.data,
                            "attachment": $scope.upload.attachment.data,
                            "kind": $scope.tab.kind == 'template' ? 'template' : 'mailbox',
                            "templateId": typeof payload.data.templateId != "undefined" ? payload.data.templateId : null

                        }, function() {
                            $rootScope.notification.showAfterRedirect(redirect, {}, 'success', "Zmiany zostały zapisane");
                        }, function() {
                            $rootScope.notification.show('error', 'Wystąpił błąd przy próbie uploadu plików');
                        });
                    } else {
                        $rootScope.notification.showAfterRedirect(redirect, {}, 'success', payload.data.msg);
                    }
                } else {
                    $rootScope.notification.show('error', payload.data.msg);
                }
            });
    };

    $scope.saveDraft = function(olddraft) {
        if ($scope.row.content.subject == "") {
            $rootScope.notification.show('danger', "Uzupełnij temat wiadomości, aby móc zapisać wiadomość");
        } else {
            if (typeof olddraft != "undefined")
                $scope.row.olddraft = 1;
            else
                $scope.row.draft = 1;

            var params = angular.copy($scope.row);

            params.content.filter.county = $scope.autocompletes.county.length > 0 ? _.map($scope.autocompletes.county, 'name').join() : "";
            params.content.filter.comunity = $scope.autocompletes.comunity.length > 0 ? _.map($scope.autocompletes.comunity, 'name').join() : "";
            params.content.filter.city = $scope.autocompletes.city.length > 0 ? _.map($scope.autocompletes.city, 'name').join() : "";
            params.content.filter.street = $scope.autocompletes.street.length > 0 ? _.map($scope.autocompletes.street, 'name').join() : "";

            params.send_date = $rootScope.formatDate(params.send_date);
            params.mobile_available = $rootScope.formatDate(params.mobile_available);

            if (params.scheduler != null) {
                if (params.scheduler.send_type == "repeat") {
                    params.scheduler.send_from = $rootScope.formatDate(params.scheduler.send_from);
                    params.scheduler.send_to = $rootScope.formatDate(params.scheduler.send_to);
                } else if (params.scheduler.send_type == "scheduler") {
                    for (var i = 0; i < params.scheduler.date.length; i++) {
                        params.scheduler.date[i].send_date = $rootScope.formatDate(params.scheduler.date[i].send_date);
                    }
                }
            }

            if ($scope.data.subunit)
                params.unit_id = $scope.data.subunit_id;
            else if (typeof units != "undefined" && units.length > 0)
                params.unit_id = units.join();

            if (typeof teams != "undefined" && teams.length > 0)
                params.team_id = teams.join();

            var promise = typeof olddraft != "undefined" ? mailboxService.update($scope.id, params) : mailboxService.store(params);
            promise.then(
                function(payload) {
                    if (payload.data.code == 1) {
                        if ($scope.upload.photo.data != "" || $scope.upload.attachment.data.length > 0) {
                            promise = mailboxService.upload({
                                "id": $scope.id ? $scope.id : payload.data.id,
                                "photo": $scope.upload.photo.data,
                                "attachment": $scope.upload.attachment.data,
                                "kind": $scope.tab.kind == 'template' ? 'template' : 'mailbox'
                            }, function() {
                                $rootScope.notification.show('success', payload.data.msg);
                            }, function() {
                                //console.log("error");
                            });
                        } else
                            $rootScope.notification.show('success', payload.data.msg);
                    } else {
                        $rootScope.notification.show('error', payload.data.msg);
                    }
                });
        }
    };

    $scope.moveFromWaiting = function() {
        var promise = mailboxService.movefromwaiting($scope.id);
        promise.then(
            function(payload) {
                if (payload.data.code == 1) {
                    $rootScope.notification.showAfterRedirect('message_drafts_msgdetails', {
                        id: $scope.id
                    }, 'success', payload.data.msg);
                } else {
                    $rootScope.notification.show('error', payload.data.msg);
                }
            });
    };

    $scope.clearScheduler = function(){
      if($scope.row.send_now){
        $scope.row.scheduler = {
            'send_type': '',
            'repeat_value': '',
            'send_from': '',
            'send_to': '',
            'date': []
        };
      }
    };

    $scope.listReady = false;
    $scope.init = function() {
        var promise;

        if ($stateParams.ids)
            promise = mailboxService.create($stateParams.ids);
        else
            promise = $scope.id ? mailboxService.edit($scope.id) : mailboxService.create();
        promise.then(
            function(payload) {
                $rootScope.filters = payload.data.filters;
                $scope.data.categories = payload.data.categories;
                $scope.search.list = payload.data.list;
                $scope.data.notifications = payload.data.notifications;
                $scope.data.languages = payload.data.languages;
                $scope.data.activeNotifications = payload.data.activeNotifications;

                if(payload.data.languages.length==1 && !$scope.id){
                  $scope.row.content.language_id = payload.data.languages[0].id;
                }

                $scope.data.subunitSupported = payload.data.subunitSupported;
                $scope.data.teamSupported = payload.data.teamSupported;

                $scope.data.subunit = payload.data.subunit;
                $scope.data.subunit_id = payload.data.subunit_id;
                if ($scope.data.subunit) {
                    $scope.row.content.unit = [payload.data.subunit_id];
                }

                for (var i = 0; i < $scope.data.notifications.length; i++) {
                    if ($scope.data.notifications[i].symbol == "mobile")
                        $scope.mobileNotificationId = "" + $scope.data.notifications[i].id;
                }

                $scope.data.sended_notifications = payload.data.sended_notifications;
                $scope.data.available_notifications = payload.data.available_notifications;
                $scope.data.emailsettings = payload.data.emailsettings;
                $scope.row.send_date = new Date();
                $scope.row.mobile_available = new Date(moment().add(payload.data.settings.default_mobile_available, 'days'));

                if(!$scope.id){
                  $scope.row.send_all_mobile_notification = 1;
                }

                if (typeof payload.data.receiver_list != "undefined") {
                    $scope.data.receiver_list = payload.data.receiver_list;
                    $scope.row.send_all_mobile_notification = 0;
                }

                if (typeof payload.data.receivers != "undefined") {
                    $scope.row.content.receiver = payload.data.receivers;
                    $scope.row.send_all_mobile_notification = 0;
                }

                if ($scope.id) {
                    if (payload.data.row.length == 0) {
                        $rootScope.notification.showAfterRedirect('message_msgnew', {}, 'error', 'Wiadomość nie została odnaleziona');
                    } else {

                        $scope.row = payload.data.row;

                        $scope.row.mobile_available = $rootScope.formatDate($scope.row.mobile_available);
                        $scope.row.send_date = $rootScope.formatDate($scope.row.send_date);
                        $scope.row.priority = payload.data.row.content.notification;

                        if ($scope.row.content.mobile_msg != ""){
                            $scope.notavailable.mobile = false;
                            $scope.notavailable.email = false;
                        }

                        if ($scope.row.scheduler != null && $scope.row.scheduler.send_type == "repeat") {
                            $scope.row.scheduler.send_from = $rootScope.formatDate($scope.row.scheduler.send_from);
                            $scope.row.scheduler.send_to = $rootScope.formatDate($scope.row.scheduler.send_to);
                        } else if ($scope.row.scheduler == null) {
                            $scope.row.scheduler = {
                                'send_type': '',
                                'repeat_value': '',
                                'send_from': '',
                                'send_to': '',
                                'date': []
                            };
                        }

                        for(var i=0; i<$scope.row.scheduler.date.length;i++){
                          $scope.row.scheduler.date[i].send_date = $rootScope.formatDateFromStringToObject($scope.row.scheduler.date[i].send_date);
                        }

                        var county = $scope.row.content.filter.county;
                        if (county) {
                            county = county.split(",");
                            for (var i = 0; i < county.length; i++) {
                                if (county[i] != "") {
                                    $scope.autocompletes.county.push({
                                        name: county[i],
                                        readonly: true
                                    });
                                }
                            }
                        }
                        var comunity = $scope.row.content.filter.comunity;
                        if (comunity) {
                            coumunity = comunity.split(",");
                            for (var i = 0; i < comunity.length; i++) {
                                if (comunity[i] != "") {
                                    $scope.autocompletes.comunity.push({
                                        name: comunity[i],
                                        readonly: true
                                    });
                                }
                            }
                        }
                        var city = $scope.row.content.filter.city;
                        if (city) {
                            city = city.split(",");
                            for (var i = 0; i < city.length; i++) {
                                if (city[i] != "") {
                                    $scope.autocompletes.city.push({
                                        name: city[i],
                                        readonly: true
                                    });
                                }
                            }
                        }
                        var street = $scope.row.content.filter.street;
                        if (street) {
                            street = street.split(",");
                            for (var i = 0; i < street.length; i++) {
                                if (street[i] != "") {
                                    $scope.autocompletes.street.push({
                                        name: street[i],
                                        readonly: true
                                    });
                                }
                            }
                        }

                        $scope.row.actions = {
                            'template': {
                                'set': false,
                                'name': ''
                            },
                            'receivergroup': {
                                'set': false,
                                'name': ''
                            }
                        };

                        var date = new Date();
                        var month = (parseInt(date.getMonth(), 10) + 1);
                        var dateString = date.getFullYear() + "-" + (month < 10 ? "0" : "") + month + "-" + date.getDate();

                        $scope.row.priority = [];
                        if ($scope.row.draft) {
                            $scope.tab.kind = "draft";
                            $scope.tab.title = "Edycja wiadomości roboczej";
                            $scope.tab.action = "drafts";
                        } else if ($scope.row.send_now == 1 || $scope.row.send_date <= dateString) {
                            $scope.tab.kind = "send";
                            $scope.tab.editable = false;
                            $scope.tab.title = "Edycja wiadomości wysłanej"
                            $scope.tab.action = "send";
                        } else if ($scope.row.send_now == 0 || $scope.row.send_date > dateString) {
                            $scope.tab.kind = "outbox";
                            $scope.tab.title = "Edycja wiadomości oczekującej";
                            $scope.tab.action = "waiting";
                        }


                        if (typeof $scope.row != "undefined" && $scope.row.content.filter.age != null && $scope.row.content.filter.age != "") {
                            var age = $scope.row.content.filter.age.split("_");
                            if (age[0] == "date") {
                                $scope.row.content.filter.age_before = new Date($scope.row.content.filter.age_before);
                                if ($scope.row.content.filter.age_after != "")
                                    $scope.row.content.filter.age_before = new Date($scope.row.content.filter.age_before);
                            } else {
                                $scope.row.content.filter.age_before = parseInt($scope.row.content.filter.age_before, 10);
                                if ($scope.row.content.filter.age_after != "")
                                    $scope.row.content.filter.age_after = parseInt($scope.row.content.filter.age_after, 10);
                            }
                        }
                    }
                }

                $scope.listReady = true;
            },
            function(errorPayload) {
                $rootScope.notification.show('error', 'Wystąpił błąd podczas próby utworzenia nowej wiadomości');
            });
    };

    $scope.init();

    $scope.upload = {
        photo: {
            data: "",
            clear: function() {
                $scope.row.content.photo = '';
                $scope.upload.photo.data = '';
            },
            change: function(file) {
                if (file) {
                    $scope.row.content.photo = '';
                    $scope.upload.photo.data = file;
                }
            }
        },
        attachment: {
            counter: 0,
            data: [],
            remove: function(id) {
                var promise = mailboxService.removeattachment({
                    'mailbox_id': $scope.id,
                    'attachment_id': id,
                    "kind": $scope.tab.kind == 'template' ? 'template' : 'mailbox'
                });
                promise.then(
                    function(payload) {
                        if (payload.data.code) {
                            $scope.row.content.attachment = payload.data.attachment;
                            $rootScope.notification.show('success', payload.data.msg);
                        } else {
                            $rootScope.notification.show('error', payload.data.msg);
                        }
                    },
                    function(errorPayload) {
                        $rootScope.notification.show('error', 'Wystąpił błąd podczas próby usunięcia załącznika');
                    });
            },
            clear: function(index) {
                var newData = [];

                for (var i = 0; i < $scope.upload.attachment.data.length; i++) {
                    if (i != index) {
                        newData.push($scope.upload.attachment.data[i]);
                    } else {
                        $rootScope.notification.show('success', 'Załącznik został usunięty');
                    }
                }
                $scope.upload.attachment.data = newData;
            },
            change: function(files) {
                if (files) {
                    for (var i = 0; i < files.length; i++) {
                        $scope.upload.attachment.data.push(files[i]);
                        $scope.upload.attachment.counter++;
                    }
                }
            }
        }
    };

    $scope.agechange = function() {
        $scope.row.content.filter.age_after = "";
        $scope.row.content.filter.age_before = "";
    };

    $scope.sendMethodChange = function() {
        if (typeof $scope.row.content.notification != "undefined") {
            $scope.notavailable.available_to = $scope.notavailable.mobile_read_confirm = $scope.notavailable.send_all_mobile_notification = $scope.row.content.notification.indexOf($scope.mobileNotificationId) == -1;
        } else {
            $scope.notavailable.available_to = $scope.notavailable.mobile_read_confirm = $scope.notavailable.send_all_mobile_notification = true;
        }

        if(typeof $scope.row.content.receiver !== "undefined" && $scope.row.content.receiver.length>0){
          $scope.notavailable.available_to = $scope.notavailable.send_all_mobile_notification = true;
        }

        if (typeof $scope.row.content.notification != "undefined" && $scope.row.priority.length != $scope.row.content.notification.length) {
            $scope.row.priority = angular.copy($scope.row.content.notification);
        } else {
            $scope.row.priority = [];
        }

        if ($scope.row.content.only_sms) {
            for (var i = 0; i < $scope.data.notifications.length; i++) {
                if ($scope.data.notifications[i].symbol == "sms") {
                    $scope.row.content.notification = ["" + $scope.data.notifications[i].id];
                    $scope.row.priority = [$scope.data.notifications[i].id];
                }
            }
        }
    };

    $scope.priorityChange = function(index) {
        for (var i = 0; i < $scope.row.priority.length; i++) {
            if (i != index && $scope.row.priority[index] == $scope.row.priority[i]) {
                var find = "";
                for (var j = 0; j < $scope.row.content.notification.length; j++) {
                    if ($scope.row.priority.indexOf($scope.row.content.notification[j]) == -1)
                        find = $scope.row.content.notification[j];
                }
                $scope.row.priority[i] = find;
            }
        }
    };

    $scope.scheduler = {
        "checkValid": function() {
            var valid = true;

            if ($scope.row.send_now == 0) {
                if ($scope.row.scheduler.send_type == 'scheduler' && $scope.row.scheduler.date.length == 0) {
                    $rootScope.notification.show('error', 'Harmonogram wysyłki musi mieć co najmniej jedną datę');
                    valid = false;
                } else {
                    var day, monthIndex, year;
                    var values = $scope.row.scheduler.date.map(function(item) {
                        if (typeof item.send_date == "string")
                            return item.send_date;
                        else {
                            day = item.send_date.getDate();
                            monthIndex = item.send_date.getMonth();
                            year = item.send_date.getFullYear();
                            return year + '-' + (monthIndex + 1 < 10 ? 0 : '') + (monthIndex + 1) + '-' + (day < 10 ? '0' : '') + day;
                        }
                    });

                    var hasDuplicate = values.some(function(item, idx) {
                        return values.indexOf(item) !== idx
                    });
                    if (hasDuplicate) {
                        $rootScope.notification.show('error', 'Terminy wysyłki w harmonogramie nie powinny się powtarzać');
                        valid = false;
                    }
                }
            }
            return valid;
        },
        "addDate": function() {
            if (typeof $scope.row.scheduler.date == "undefined")
                $scope.row.scheduler.date = [];
            $scope.row.scheduler.date.push({
                "send_date": new Date()
            });
        },
        "removeDate": function(term) {
            var removeElement = _.filter($scope.row.scheduler.date, {
                '$$hashKey': term.$$hashKey
            });
            $scope.row.scheduler.date = _.difference($scope.row.scheduler.date, removeElement);
        }
    };

    $scope.mobileAvailableMinDate = function(){
      var now = new Date();
      return new Date(
        now.getFullYear(),
        now.getMonth(),
        now.getDate()
      );
    };

    $scope.showMapDialog = function(){
      $mdDialog.show({
          templateUrl: 'map.html',
          controller: mapDialog,
          onComplete: function(){
            setTimeout(function(){
              uiGmapGoogleMapApi.then(function(maps) {
                $scope.map.object =  {
                  center: {
                    latitude: 45,
                    longitude: -73
                  },
                  zoom: 8
                };
              });
            },1000);
          }
      });
    };
    function mapDialog($scope, $mdDialog) {
       $scope.closeDialog = function() {
         $mdDialog.hide();
       };
    };
});

// app.controller('mapDialog',function($scope, $mdDialog, items) {
//    $scope.items = items;
//    $scope.closeDialog = function() {
//      $mdDialog.hide();
//    };
// });
